import { useState, useRef, useEffect } from 'react';

import styled from 'styled-components';

import WhiteTrashIcon from '../../image/WhiteTrashIcon.png';
import { ReactComponent as LeftArrowSvg } from '../../image/LeftArrow.svg';

export default function PaymentOptionSettingSelectBox(props) {
  const {
    index,
    value,
    setValue,
    options,
    disabled,
    onClickAdditionOption,
    onClickDeleteOption
  } = props;

  const [isClicked, setIsClicked] = useState(false);

  const TopLevelRef = useRef();

  // 컴포넌트 외부 클릭 감지 리스너 연결 //
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  // 컴포넌트 외부 클릭시 닫기 //
  function onClickOutSide(e) {
    if (TopLevelRef.current !== e.target && !TopLevelRef.current.contains(e.target)) {
      setIsClicked(false);
    }
  }

  // 선택박스 클릭시 //
  function onClickSelectBox() {
    if (disabled) return;
    if (!options[0]) return;

    setIsClicked(prev => !prev);
  }

  // 옵션 클릭시 //
  function onClickOption(e, optionIndex) {
    e.stopPropagation();
    setValue(options[optionIndex], index);
    setIsClicked(false);
  }

  // 옵션 삭제 버튼 클릭시 //
  function onClickDeleteOptionButton(e, optionId) {
    e.stopPropagation();
    onClickDeleteOption(optionId);
    setIsClicked(false);
  }

  // 옵션 추가 버튼 클릭시 //
  function onClickAdditionOptionButton(e) {
    e.stopPropagation();
    onClickAdditionOption();
    setIsClicked(false);
  }

  return (
    <TopLevelWrapper ref={TopLevelRef}>
      <SelectBox onClick={onClickSelectBox}>
        <SelectTextWrapper>
          <SelectText>{value.name}</SelectText>
        </SelectTextWrapper>
        <ArrowWrapper>
          <StyledDownArrow isOpen={isClicked} />
        </ArrowWrapper>
      </SelectBox>
      {
        isClicked &&
        <DropdownList>
          {
            options.map((optionData, optionIndex) => (
              <DropdownItem
                key={'PaymentOptions-' + optionIndex}
                onClick={(e) => onClickOption(e, optionIndex)}>
                <DropdownItemText>{optionData.name}</DropdownItemText>
                {
                  optionData.id !== 0 &&
                  <DeleteButton onClick={(e) => onClickDeleteOptionButton(e, optionData.id)}>
                    <DeleteIcon src={WhiteTrashIcon} />
                  </DeleteButton>
                }
              </DropdownItem>
            ))
          }
          <DropdownItem onClick={onClickAdditionOptionButton}>
            <AddOptionText>+ 결제 수단 추가</AddOptionText>
          </DropdownItem>
        </DropdownList>
      }
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  width: 100%;
`;

const SelectBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 5px 10px;

  width: 100%;
  height: 50px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};
  box-sizing: border-box;

  cursor: pointer;
`;

const SelectTextWrapper = styled.div`
  display: flex;
  align-items: center;

  flex: 1;
  height: 40px;
  overflow: hidden;
`;

const SelectText = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;
  color: ${props => props.theme.text};

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const ArrowWrapper = styled.span`
  display: flex;
  align-items: center;

  margin-left: 8px;
`;

const StyledDownArrow = styled(LeftArrowSvg)`
  width: 10px;
  height: auto;

  color: ${props => props.theme.subText};

  transform: ${props => props.isOpen ? 'rotate(90deg)' : 'rotate(-90deg)'};
  transition: transform 0.2s ease-in-out;
`;

const DropdownList = styled.div`
  position: absolute;

  top: calc(100% + 4px);
  left: 0;

  width: 100%;
  max-height: 200px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};

  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  overflow-y: auto;

  z-index: 100;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${props => props.theme.scrollBar};
    border-radius: 200px;
  }

  &::-webkit-scrollbar-track {
    background-color: ${props => props.theme.subBackground};
    border-radius: 200px;
  }
`;

const DropdownItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  padding: 8px 12px;

  gap: 8px;

  cursor: pointer;

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      background-color: ${props => props.theme.primary};
    }
  }
`;

const DropdownItemText = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;
  color: ${props => props.theme.text};

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const AddOptionText = styled.span`
  font-family: NotoSansKR-Medium;
  font-size: 14px;
  color: ${props => props.theme.primary};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    ${DropdownItem}:hover & {
      color: ${props => props.theme.subBackground};
    }
  }
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 18px;

  border-radius: 2px;
  background-color: ${props => props.theme.pointRed}80;

  flex-shrink: 0;

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.pointRed};
    }
  }
`;

const DeleteIcon = styled.img`
  width: 14px;
  height: 14px;
`;
